import {defaultConfiguration, defaultConfigurationApi, defaultConfigurationModules, IConfiguration} from "../configuration.state";

const CONFIGURATION_REDFACTORY: IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443',
    apiUrls: {
      ...defaultConfigurationApi.apiUrls,
      apiWorkflowUrl: {apiVersion: 3, url: '/wf'}
    }
  },
  theme: 'portal',
  language: {
    defaultLang: 'ru',
    showLang: true,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,

      loginType: 'redfactory',
      goFAQ: '',
      supportEmail: 'support@redfactory.io',
      enableSelfRegistration: true,
      enableGoogleSignIn: false,
      showTutorialVideo: false,
      showTryDemoButton: true,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main: {
      showSupportBlock: true,
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showAddressForPartner: true
    }
  }
};


export const CONFIGURATION_REDFACTORY_DEV:IConfiguration = {
  ...CONFIGURATION_REDFACTORY

};
export const CONFIGURATION_REDFACTORY_PROD:IConfiguration = {
  ...CONFIGURATION_REDFACTORY

};


